<template>
  <div class="email-form-item-side-nav">
    <h6>{{ $t('text') }}</h6>

    <span>{{ $t('label') }}:</span>
    <Input
      :value="options.label"
      @blur="propChanged('label', $event)"
      @enter="propChanged('label', $event)"
      :disabled="true"
    />
    <span>{{ $t('placeholder') }}:</span>
    <Input
      :value="options.placeholder"
      @blur="propChanged('placeholder', $event)"
      @enter="propChanged('placeholder', $event)"
    />
    <Toggle
      :label="$t('required')"
      :value="options.required"
      @toggle="propChanged('required', $event)"
      :disabled="options.cantChangeRequired"
    />
  </div>
</template>

<script>
import Mixin from './Mixin.js'
import ComponentsMixin from '@/components/Mixin.js'

export default {
  name: 'EmailFormItemSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.form.form-item.email' },
  mixins: [Mixin, ComponentsMixin],
}
</script>
